/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePushNotificationDto } from '../models/CreatePushNotificationDto';
import type { CreatePushNotificationResultDto } from '../models/CreatePushNotificationResultDto';
import type { PushNotificationAudienceInputDto } from '../models/PushNotificationAudienceInputDto';
import type { PushNotificationAudiencePreviewDto } from '../models/PushNotificationAudiencePreviewDto';
import type { PushNotificationCapabilitiesDto } from '../models/PushNotificationCapabilitiesDto';
import type { PushNotificationDeliveriesPagedResultDto } from '../models/PushNotificationDeliveriesPagedResultDto';
import type { PushNotificationDetailDto } from '../models/PushNotificationDetailDto';
import type { PushNotificationsPagedResultDto } from '../models/PushNotificationsPagedResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminPushNotificationsService {
  /**
   * @returns PushNotificationCapabilitiesDto
   * @throws ApiError
   */
  public static adminPushNotificationsControllerCapabilities(): CancelablePromise<PushNotificationCapabilitiesDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/push-notifications/capabilities',
    });
  }
  /**
   * @param requestBody
   * @returns PushNotificationAudiencePreviewDto
   * @throws ApiError
   */
  public static adminPushNotificationsControllerPreview(
    requestBody: PushNotificationAudienceInputDto,
  ): CancelablePromise<PushNotificationAudiencePreviewDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/push-notifications/audience-preview',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Durably queue a push notification.
   * @param idempotencyKey
   * @param requestBody
   * @returns CreatePushNotificationResultDto
   * @throws ApiError
   */
  public static adminPushNotificationsControllerCreate(
    idempotencyKey: string,
    requestBody: CreatePushNotificationDto,
  ): CancelablePromise<CreatePushNotificationResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/push-notifications',
      headers: {
        'Idempotency-Key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param page
   * @param limit
   * @returns PushNotificationsPagedResultDto
   * @throws ApiError
   */
  public static adminPushNotificationsControllerList(
    page: number = 1,
    limit: number = 25,
  ): CancelablePromise<PushNotificationsPagedResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/push-notifications',
      query: {
        page: page,
        limit: limit,
      },
    });
  }
  /**
   * @param id
   * @returns PushNotificationDetailDto
   * @throws ApiError
   */
  public static adminPushNotificationsControllerDetail(
    id: string,
  ): CancelablePromise<PushNotificationDetailDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/push-notifications/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param page
   * @param limit
   * @returns PushNotificationDeliveriesPagedResultDto
   * @throws ApiError
   */
  public static adminPushNotificationsControllerDeliveries(
    id: string,
    page: number = 1,
    limit: number = 25,
  ): CancelablePromise<PushNotificationDeliveriesPagedResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/push-notifications/{id}/deliveries',
      path: {
        id: id,
      },
      query: {
        page: page,
        limit: limit,
      },
    });
  }
}
